<template>
  <van-sticky>
    <div :style="{
      display:'flex',
      flexDirection:'row',
      backgroundColor:'#0000',
      alignItems:'flex-end',
      justifyContent:'flex-start',
      height:'50px',
      backgroundImage:`url(${iconTop_tabs})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'left',
    }">
      <div @click="onChange(index)" v-for="(tab,index) in tabs" :key="tab.title">
        <div :style="getTitleStyle(index)">
          {{tab.title}}
        </div>
      </div>
    </div>
    <div id="activity-tag-row-slot" v-show="tabs[swiperIndex] && tabs[swiperIndex].comp === 'Activity'"></div>
  </van-sticky>
  <van-swipe  ref="swipeRef" :loop="false" lazy-render :show-indicators="false" @change="onChange">
    <van-swipe-item v-for="(tab,index) in tabs" :key="tab.title">
      <Activity v-if="tab.comp === 'Activity'"/>
      <Discount tag="tabReward" v-if="tab.comp === 'Discount'" :hideNav="true"/>
      <Vip :dynamicColoCallback="dynamicColorCallback" v-if="tab.comp === 'Vip'" :hideNav="true"/>
    </van-swipe-item>
  </van-swipe>
  <HDatePicker onlyShowPopup="true" tag="tabReward"/>
</template>

<script setup>
  import {ref} from 'vue';
  import Activity from "@/components/pages/Activity/Activity.vue";
  import Discount from "@/components/pages/Discount/Discount.vue";
  import Vip from "@/components/pages/Vip.vue";
  import HDatePicker from "@/components/utils/HDatePicker.vue";
  import iconTop_tabs from "@/assets/icons/common/top_tabs_bg.png"

  const swiperIndex = ref(0);
  const dynamicColor = ref("#0000");

  // 活动功能暂未上线: 把"优惠活动"项的 enabled 改回 true 即可恢复该 tab
  const allTabs = [
    {title: '优惠活动', comp: 'Activity', enabled: false},
    {title: '洗码返水', comp: 'Discount', enabled: true},
    {title: 'VIP特权', comp: 'Vip', enabled: true},
  ];
  const tabs = allTabs.filter(t => t.enabled);
  const swipeRef = ref();
  function onChange(index) {
    window.scrollTo({
      top: -10,
    });
    swiperIndex.value = index;
    swipeRef.value.swipeTo(index);
  }

  function dynamicColorCallback(color){
    dynamicColor.value = color;
  }

  const getTitleStyle = (index) => {
    let shouldColor = "";
    if(swiperIndex.value === index){
      shouldColor = "white";
    }else{
      shouldColor = "#ddd";
    }
    return {
      fontSize: swiperIndex.value === index ? '18px' : '14px',
      transition: 'font-size 0.3s',
      color: shouldColor,
      marginLeft:index === 0?'10px':'30px',
      marginBottom:'5px',
      fontWeight:'bold',
    };
  };
</script>

<style scoped>
  /* 穿透 van-tabs 的内部样式，取消平均分配宽度 */
  ::v-deep(.van-tabs__wrap) {
    justify-content: flex-start !important;
  }

  ::v-deep(.van-tabs__nav) {
    display: flex !important;
    justify-content: flex-start !important;
  }

  ::v-deep(.van-tab) {
    flex: 0 0 auto !important;
  }
</style>
